import React, { useEffect, useState, lazy, createElement } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { ArrowRight, MapPin, Instagram, Quote } from 'lucide-react';
import { Link } from 'react-router-dom';
const CATEGORIES = [{
  name: 'Accessories',
  link: '/23m8/accessories.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FCategory%20Images%2FAccessories2.JPG'
}, {
  name: 'Apparel',
  link: '/23m8/apparel.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FCategory%20Images%2Fapparel.JPG'
}, {
  name: 'Bathrooms',
  link: '/23m8/bathrooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBathrooms%2FBathroom5.jpg'
}, {
  name: 'Bedrooms',
  link: '/23m8/bedrooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBedrooms%2FBedrooms1.JPG'
}, {
  name: 'Before & After',
  link: '/23m8/before-after.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBefore%20%26%20After%2F140508121027.jpg'
}, {
  name: 'Commercial',
  link: '/23m8/commercial.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1013937.jpg'
}, {
  name: 'Dining Rooms',
  link: '/23m8/dining-rooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014171.jpg'
}, {
  name: 'Furniture',
  link: '/23m8/furniture.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBedrooms%2FIMG_9817.JPG'
}, {
  name: 'Kitchens',
  link: '/23m8/kitchens.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014168.jpg'
}, {
  name: 'Lighting',
  link: '/23m8/lighting.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2Flighting%20and%20bathroom.jpg'
}, {
  name: 'Living Rooms',
  link: '/23m8/living-rooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014111.jpg'
}, {
  name: 'Lower Levels',
  link: '/23m8/lower-levels.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2Flower%20level.jpg'
}, {
  name: 'Seminars and Events',
  link: '/23m8/seminars-and-events.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FIMG_3233.jpg'
}, {
  name: 'Staging',
  link: '/23m8/staging.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FBlog%20Images%2Fclutter%20free.jpg'
}, {
  name: 'Window Treatments',
  link: '/23m8/window-treatments.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1013895.jpg'
}];
export function Home() {
  const [activeVideo, setActiveVideo] = useState<'guided' | 'walkthrough'>('guided');
  useEffect(() => {
    // Load Instagram embed script
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <Layout data-id="element-316">
      {/* Hero Section */}
      <section className="relative h-[85vh] min-h-[700px] flex items-center justify-center overflow-hidden" data-id="element-317">
        {/* Hero Background Image */}
        <div className="absolute inset-0" data-id="element-318">
          <img src="https://cdn.magicpatterns.com/uploads/5A4TPYYR2WrTmfkNvb36Jw/hero1.jpg" alt="Down Home Interiors Showroom" className="w-full h-full object-cover object-center" data-id="element-319" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/60 via-charcoal-900/30 to-charcoal-900/40" data-id="element-320" />

        <div className="relative z-20 text-center max-w-5xl px-4" data-id="element-321">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-white mb-6 leading-[1.1] drop-shadow-lg" data-id="element-322">
            Timeless Interiors for
            <br data-id="element-323" />
            Michigan Homes
          </h1>
          <p className="text-xl md:text-2xl text-white/95 mb-12 font-light max-w-3xl mx-auto leading-relaxed drop-shadow-md" data-id="element-324">
            Full-service interior design, curated home décor, professional
            staging, and a thoughtfully selected apparel boutique in Howell,
            Michigan—serving nearby Brighton and surrounding communities.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-325">
            <Link to="/portfolio" data-id="element-326">
              <Button size="lg" className="min-w-[200px]" data-id="element-327">
                View Portfolio
              </Button>
            </Link>
            <Link to="/store-info" data-id="element-328">
              <Button variant="outline" size="lg" className="min-w-[200px] bg-white/10 backdrop-blur-sm text-white border-white hover:bg-white hover:text-charcoal-900" data-id="element-329">
                Visit the Store
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Intro/Brand Statement */}
      <section className="py-20 px-4 bg-white border-y border-taupe-200" data-id="element-330">
        <div className="max-w-4xl mx-auto text-center" data-id="element-331">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-332">
            Welcome to Down Home Interiors
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-8 leading-tight" data-id="element-333">
            Where Timeless Design Meets Personal Style
          </h2>
          <div className="prose prose-lg prose-stone mx-auto" data-id="element-334">
            <p className="text-lg text-charcoal-900/70 leading-relaxed mb-0" data-id="element-335">
              For over two decades, Down Home Interiors has been the trusted
              name in interior design throughout Howell and surrounding
              communities. We offer full-service interior decorating, a
              carefully curated retail collection of home décor and apparel, and
              professional real estate staging that helps homes sell faster and
              for more.
            </p>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-336">
        <div className="max-w-5xl mx-auto" data-id="element-337">
          <div className="text-center mb-12" data-id="element-338">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-339">
              Take a Tour
            </h2>
            <p className="text-charcoal-900/60" data-id="element-340">
              Experience our showroom from anywhere
            </p>
          </div>

          {/* Video Tabs */}
          <div className="flex justify-center gap-4 mb-8" data-id="element-341">
            <button onClick={() => setActiveVideo('guided')} className={`px-6 py-3 text-sm font-medium uppercase tracking-wide transition-all ${activeVideo === 'guided' ? 'text-charcoal-900 border-b-2 border-sage-500' : 'text-charcoal-900/50 hover:text-charcoal-900'}`} data-id="element-342">
              Guided Tour
            </button>
            <button onClick={() => setActiveVideo('walkthrough')} className={`px-6 py-3 text-sm font-medium uppercase tracking-wide transition-all ${activeVideo === 'walkthrough' ? 'text-charcoal-900 border-b-2 border-sage-500' : 'text-charcoal-900/50 hover:text-charcoal-900'}`} data-id="element-343">
              Walkthrough Tour
            </button>
          </div>

          {/* Video Container */}
          <div className="bg-white p-4 md:p-8 shadow-soft border border-taupe-200" data-id="element-344">
            <div className="aspect-video bg-taupe-200 flex items-center justify-center" data-id="element-345">
              {activeVideo === 'guided' ? <iframe title="vimeo-player" src="https://player.vimeo.com/video/1028622132?h=ee619bb12b" className="w-full h-full" frameBorder="0" referrerPolicy="strict-origin-when-cross-origin" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen data-id="element-346" /> : <iframe title="vimeo-player" src="https://player.vimeo.com/video/1028622101?h=3e969e1539" className="w-full h-full" frameBorder="0" referrerPolicy="strict-origin-when-cross-origin" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen data-id="element-347" />}
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio/Services Category Grid */}
      <section className="py-24 px-4 bg-white" data-id="element-348">
        <div className="max-w-7xl mx-auto" data-id="element-349">
          <div className="text-center mb-16" data-id="element-350">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-351">
              Explore Our Work
            </h2>
            <p className="text-lg text-charcoal-900/60" data-id="element-352">
              From complete renovations to curated décor, discover our portfolio
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-353">
            {CATEGORIES.map(category => <a key={category.name} href={category.link} className="group relative aspect-[3/4] bg-taupe-200 overflow-hidden border border-taupe-300 hover:shadow-soft transition-all duration-300" data-id="element-354">
                {/* Category Image */}
                <img src={category.image} alt={category.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-355" />

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/80 via-charcoal-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-356" />

                {/* Category Name */}
                <div className="absolute bottom-0 left-0 right-0 p-4 text-center transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300" data-id="element-357">
                  <h3 className="text-white font-serif text-lg group-hover:text-sage-200 transition-colors" data-id="element-358">
                    {category.name}
                  </h3>
                </div>
              </a>)}
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="py-24 px-4 bg-taupe-200/30" data-id="element-359">
        <div className="max-w-6xl mx-auto" data-id="element-360">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-361">
            <div className="flex justify-center items-center" data-id="element-362">
              <div className="w-full max-w-sm" data-id="element-363">
                <img src="https://cdn.magicpatterns.com/uploads/bMv2J1DMEZqGf6BQQtjjrF/shopping-local.jpg" alt="Denise Down - Owner of Down Home Interiors" className="w-full h-auto object-cover rounded-sm shadow-card" data-id="element-364" />
              </div>
            </div>
            <div data-id="element-365">
              <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-4 block" data-id="element-366">
                Our Story
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-367">
                Passion Meets Experience
              </h2>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-368">
                For over 20 years, Down Home Interiors has been transforming
                spaces throughout Howell and beyond. Our founder brings a
                passion for timeless design and a commitment to personalized
                service that makes every project unique.
              </p>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-8" data-id="element-369">
                We believe great design is about understanding how you live,
                what you love, and creating spaces that feel authentically
                yours. From initial consultation to final installation, we're
                with you every step of the way.
              </p>
              <Link to="/about" data-id="element-370">
                <Button variant="outline" className="group" data-id="element-371">
                  Read More About Us
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-372" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Retail Store Highlight */}
      <section className="py-24 px-4 bg-white" data-id="element-373">
        <div className="max-w-6xl mx-auto" data-id="element-374">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-375">
            <div className="lg:order-2 aspect-[4/3] overflow-hidden" data-id="element-376">
              <img src="https://cdn.magicpatterns.com/uploads/w7gQ2Gwv3FYca1ogekqJxr/image.png" alt="Down Home Interiors Showroom" className="w-full h-full object-cover" data-id="element-377" />
            </div>
            <div className="lg:order-1" data-id="element-378">
              <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-4 block" data-id="element-379">
                Visit Our Showroom
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-380">
                Experience Design in Person
              </h2>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-381">
                Step into our beautifully curated showroom where you'll find an
                ever-changing collection of home décor, furniture, apparel, and
                accessories. Our knowledgeable team is always available to offer
                design advice and help you find exactly what you're looking for.
              </p>

              <div className="bg-cream-50 p-6 border border-taupe-200 mb-8" data-id="element-382">
                <div className="flex items-start mb-4" data-id="element-383">
                  <MapPin className="text-sage-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-384" />
                  <address className="not-italic text-charcoal-900" data-id="element-385">
                    <strong className="block mb-1" data-id="element-386">Down Home Interiors</strong>
                    <a href="https://www.google.com/maps/search/?api=1&query=2729+E.+Grand+River+Ave.+Howell+MI+48843" target="_blank" rel="noopener noreferrer" className="hover:text-sage-500 transition-colors" data-id="element-387">
                      2729 E. Grand River Ave.
                      <br data-id="element-388" />
                      Howell, MI 48843
                    </a>
                  </address>
                </div>
                <p className="text-sm text-charcoal-900/60 ml-8" data-id="element-389">
                  Open Monday–Saturday
                </p>
              </div>

              <a href="https://www.google.com/maps/search/?api=1&query=2729+E.+Grand+River+Ave.+Howell+MI+48843" target="_blank" rel="noopener noreferrer" data-id="element-390">
                <Button data-id="element-391">Get Directions</Button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Preview */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-392">
        <div className="max-w-6xl mx-auto" data-id="element-393">
          <div className="text-center mb-16" data-id="element-394">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-395">
              What Our Clients Say
            </h2>
            <p className="text-lg text-charcoal-900/60" data-id="element-396">
              Trusted by homeowners throughout Michigan
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-397">
            {[{
            quote: 'Working with Down Home Interiors transformed our house into a home. Their attention to detail and understanding of our style was remarkable.',
            author: 'Sarah M.',
            location: 'Brighton'
          }, {
            quote: 'The staging services helped us sell our home in record time. Professional, creative, and worth every penny.',
            author: 'Michael & Jennifer T.',
            location: 'Howell'
          }, {
            quote: 'From consultation to installation, the team made the entire process seamless. Our living room has never looked better.',
            author: 'Patricia L.',
            location: 'Hartland'
          }].map((testimonial, index) => <div key={index} className="bg-white p-8 shadow-card border border-taupe-200 relative" data-id="element-398">
                <Quote className="absolute top-6 left-6 text-sage-200 h-8 w-8" data-id="element-399" />
                <div className="relative z-10 pt-8" data-id="element-400">
                  <p className="text-charcoal-900/70 italic mb-6 leading-relaxed" data-id="element-401">
                    "{testimonial.quote}"
                  </p>
                  <div data-id="element-402">
                    <p className="font-serif font-medium text-charcoal-900" data-id="element-403">
                      {testimonial.author}
                    </p>
                    <p className="text-xs text-charcoal-900/50 uppercase tracking-wide" data-id="element-404">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="text-center" data-id="element-405">
            <Link to="/testimonials" data-id="element-406">
              <Button variant="outline" data-id="element-407">View All Testimonials</Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Instagram Section */}
      <section className="py-24 px-4 bg-white border-y border-taupe-200" data-id="element-408">
        <div className="max-w-6xl mx-auto" data-id="element-409">
          <div className="text-center mb-12" data-id="element-410">
            <Instagram className="h-12 w-12 text-sage-500 mx-auto mb-6" data-id="element-411" />
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-412">
              Follow Our Journey
            </h2>
            <p className="text-lg text-charcoal-900/60 mb-8" data-id="element-413">
              See our latest projects and design inspiration on Instagram
            </p>
          </div>

          {/* Instagram Embed */}
          <div className="flex justify-center mb-8 max-w-4xl mx-auto" data-id="element-414">
            <blockquote className="instagram-media" data-instgrm-permalink="https://www.instagram.com/downhomeinteriors/?utm_source=ig_embed&utm_campaign=loading" data-instgrm-version="14" style={{
            background: '#FFF',
            border: 0,
            borderRadius: '3px',
            boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
            margin: '1px',
            maxWidth: '100%',
            minWidth: '326px',
            padding: 0,
            width: '100%'
          }} data-id="element-415">
              <div style={{
              padding: '16px'
            }} data-id="element-416">
                <a href="https://www.instagram.com/downhomeinteriors/?utm_source=ig_embed&utm_campaign=loading" style={{
                background: '#FFFFFF',
                lineHeight: 0,
                padding: '0 0',
                textAlign: 'center',
                textDecoration: 'none',
                width: '100%'
              }} target="_blank" rel="noopener noreferrer" data-id="element-417">
                  <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }} data-id="element-418">
                    <div style={{
                    backgroundColor: '#F4F4F4',
                    borderRadius: '50%',
                    flexGrow: 0,
                    height: '40px',
                    marginRight: '14px',
                    width: '40px'
                  }} data-id="element-419"></div>
                    <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    justifyContent: 'center'
                  }} data-id="element-420">
                      <div style={{
                      backgroundColor: '#F4F4F4',
                      borderRadius: '4px',
                      flexGrow: 0,
                      height: '14px',
                      marginBottom: '6px',
                      width: '100px'
                    }} data-id="element-421"></div>
                      <div style={{
                      backgroundColor: '#F4F4F4',
                      borderRadius: '4px',
                      flexGrow: 0,
                      height: '14px',
                      width: '60px'
                    }} data-id="element-422"></div>
                    </div>
                  </div>
                  <div style={{
                  padding: '19% 0'
                }} data-id="element-423"></div>
                  <div style={{
                  display: 'block',
                  height: '50px',
                  margin: '0 auto 12px',
                  width: '50px'
                }} data-id="element-424">
                    <svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg" data-id="element-425">
                      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" data-id="element-426">
                        <g transform="translate(-511.000000, -20.000000)" fill="#000000" data-id="element-427">
                          <g data-id="element-428">
                            <path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631" data-id="element-429"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div style={{
                  paddingTop: '8px'
                }} data-id="element-430">
                    <div style={{
                    color: '#3897f0',
                    fontFamily: 'Arial,sans-serif',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 550,
                    lineHeight: '18px'
                  }} data-id="element-431">
                      View this profile on Instagram
                    </div>
                  </div>
                  <div style={{
                  padding: '12.5% 0'
                }} data-id="element-432"></div>
                </a>
                <p style={{
                color: '#c9c8cd',
                fontFamily: 'Arial,sans-serif',
                fontSize: '14px',
                lineHeight: '17px',
                marginBottom: 0,
                marginTop: '8px',
                overflow: 'hidden',
                padding: '8px 0 7px',
                textAlign: 'center',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }} data-id="element-433">
                  <a href="https://www.instagram.com/downhomeinteriors/?utm_source=ig_embed&utm_campaign=loading" style={{
                  color: '#c9c8cd',
                  fontFamily: 'Arial,sans-serif',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  lineHeight: '17px'
                }} target="_blank" rel="noopener noreferrer" data-id="element-434">
                    Down Home Interiors & Apparel
                  </a>{' '}
                  (@
                  <a href="https://www.instagram.com/downhomeinteriors/?utm_source=ig_embed&utm_campaign=loading" style={{
                  color: '#c9c8cd',
                  fontFamily: 'Arial,sans-serif',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  lineHeight: '17px'
                }} target="_blank" rel="noopener noreferrer" data-id="element-435">
                    downhomeinteriors
                  </a>
                  ) • Instagram photos and videos
                </p>
              </div>
            </blockquote>
          </div>

          <div className="text-center" data-id="element-436">
            <a href="https://www.instagram.com/downhomeinteriors/" target="_blank" rel="noopener noreferrer" data-id="element-437">
              <Button variant="outline" data-id="element-438">
                <Instagram className="mr-2 h-4 w-4" data-id="element-439" />
                Follow @downhomeinteriors
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-24 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100" data-id="element-440">
        <div className="max-w-4xl mx-auto text-center" data-id="element-441">
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-442">
            Ready to Transform Your Space?
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-443">
            Schedule a consultation and discover how we can bring your vision to
            life with personalized design solutions.
          </p>
          <Link to="/contact" data-id="element-444">
            <Button size="lg" className="min-w-[200px]" data-id="element-445">
              Contact Us
            </Button>
          </Link>
        </div>
      </section>
    </Layout>;
}